var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	84432: () => (loadStrictSingletonVersion("default", "react", false, [4,18,3,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	49823: () => (loadStrictSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	19740: () => (loadStrictVersion("default", "@emotion/react", false, [1,11,11,4], () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(1777)]).then(() => (() => (__webpack_require__(54158))))))),
	78115: () => (loadStrictVersion("default", "@emotion/styled", false, [1,11,11,5], () => (__webpack_require__.e(3860).then(() => (() => (__webpack_require__(71479))))))),
	14744: () => (loadStrictVersion("default", "uuid", false, [1,11,1,0], () => (__webpack_require__.e(3419).then(() => (() => (__webpack_require__(93419))))))),
	22438: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(5468).then(() => (() => (__webpack_require__(35468))))))),
	95965: () => (loadStrictVersion("default", "axios", false, [4,1,15,2], () => (__webpack_require__.e(1914).then(() => (() => (__webpack_require__(31914))))))),
	5285: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,22,3], () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(92648))))))),
	88034: () => (loadStrictVersion("default", "@mui/material", false, [1,5,15,15], () => (Promise.all([__webpack_require__.e(5463), __webpack_require__.e(4164), __webpack_require__.e(7431)]).then(() => (() => (__webpack_require__(37431))))))),
	94808: () => (loadStrictVersion("default", "@DeepHealth/dhosdesigntokens", false, [4,0,0,24], () => (__webpack_require__.e(3467).then(() => (() => (__webpack_require__(63467))))))),
	6266: () => (loadStrictVersion("default", "styled-components", false, [1,6,1,8], () => (__webpack_require__.e(9598).then(() => (() => (__webpack_require__(9598))))))),
	29518: () => (loadSingletonVersion("default", "i18next", false, [1,23,10,1], () => (__webpack_require__.e(2526).then(() => (() => (__webpack_require__(82526))))))),
	31415: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,2,8,2], () => (__webpack_require__.e(4319).then(() => (() => (__webpack_require__(24319))))))),
	32147: () => (loadStrictVersion("default", "redux-persist-indexeddb-storage", false, [1,1,0,4], () => (__webpack_require__.e(2863).then(() => (() => (__webpack_require__(12863))))))),
	33765: () => (loadStrictVersion("default", "zustand", false, [1,4,5,4], () => (__webpack_require__.e(6466).then(() => (() => (__webpack_require__(34085))))))),
	66540: () => (loadStrictVersion("default", "redux-persist", false, [1,6,0,0], () => (__webpack_require__.e(1385).then(() => (() => (__webpack_require__(41385))))))),
	77806: () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,5,28,14], () => (__webpack_require__.e(5946).then(() => (() => (__webpack_require__(85946))))))),
	79982: () => (loadStrictSingletonVersion("default", "@DeepHealth/dhos-common-utils", false, [4,1,0,7], () => (Promise.all([__webpack_require__.e(2380), __webpack_require__.e(6373), __webpack_require__.e(4694)]).then(() => (() => (__webpack_require__(96373))))))),
	83750: () => (loadStrictVersion("default", "react-redux", false, [1,9,2,0], () => (__webpack_require__.e(5135).then(() => (() => (__webpack_require__(45135))))))),
	85011: () => (loadStrictVersion("default", "module-federation-import-remote", false, [1,1,0,24], () => (__webpack_require__.e(8715).then(() => (() => (__webpack_require__(48715))))))),
	98209: () => (loadStrictVersion("default", "@DeepHealth/component-library", false, [4,1,0,76], () => (Promise.all([__webpack_require__.e(5463), __webpack_require__.e(3780)]).then(() => (() => (__webpack_require__(53780))))))),
	16769: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(2366).then(() => (() => (__webpack_require__(62366))))))),
	25701: () => (loadStrictSingletonVersion("default", "@apollo/client", false, [1,3,11,0], () => (Promise.all([__webpack_require__.e(4958), __webpack_require__.e(4432)]).then(() => (() => (__webpack_require__(14958))))))),
	72410: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(3855).then(() => (() => (__webpack_require__(73855))))))),
	80724: () => (loadStrictVersion("default", "@opentelemetry/api", false, [1,1,9,0], () => (__webpack_require__.e(8314).then(() => (() => (__webpack_require__(28314))))))),
	83558: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(1003).then(() => (() => (__webpack_require__(91003)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1516": [
		6266,
		29518,
		31415,
		32147,
		33765,
		66540,
		77806,
		79982,
		83750,
		85011,
		98209
	],
	"4347": [
		5285,
		88034,
		94808
	],
	"4432": [
		84432
	],
	"4694": [
		16769,
		25701,
		72410,
		80724,
		83558
	],
	"8115": [
		78115
	],
	"9695": [
		14744,
		22438,
		95965
	],
	"9740": [
		19740
	],
	"9823": [
		49823
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}